import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { LanguageAssignmentsSelectors } from './language-assignments.selectors';
import { LanguageAssignmentsActions } from './language-assignments.actions';
import {AsyncActionQueries, AsyncActionSelectors} from '@emm/core/util/async-action-state';
import {AsyncActionStoreService} from '@emm/core/store/async-action-store.service';
import {State as CoreState} from '@emm/core/store/core.reducer';
import {ManagementBaseSelectors} from '@emm/management/store/base/management-base.selectors';
import {ManagementBaseActions} from '@emm/management/store/base/management-base.actions';

export interface LanguageAssignmentsQueries extends AsyncActionQueries {
    all$: Observable<any>;
    locations$: Observable<any>;
}

@Injectable({
    providedIn: 'root',
})
export class LanguageAssignmentsStoreService extends AsyncActionStoreService<AsyncActionSelectors> {
    constructor(store: Store<CoreState>) {
        super(store, LanguageAssignmentsSelectors);
    }

    dispatch = {
        initLanguageAssignments: () => this.store.dispatch(LanguageAssignmentsActions.initLanguageAssignments()),
        updateLanguageAssignmentLocations: (consumer) => this.store.dispatch(ManagementBaseActions.loadAllLocation()),
    };

    queries: LanguageAssignmentsQueries = {
        all$: this.selectNonNil(ManagementBaseSelectors.getFilteredItems),
        locations$: this.selectNonNil(ManagementBaseSelectors.getLocations),
        ...this.asyncActionQueries,
    };
}
